import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-headline',
  standalone: true,
  imports: [],
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeadlineComponent {}
